module.exports = __webpack_public_path__ + "static/pic02-19dbb096bf0bb0c1ad4313bd535f4cbb.jpg";